import { defaultCaseProperties } from '../../../../../../resources/defaultCaseProperties';
import { Property } from '../../../Property';

export const getCasePropertyDefaultValue = (propertyName: string): number =>
  (defaultCaseProperties.find((property) => property.name === propertyName) as Property)
    .defaultValue;
